module.exports = __webpack_public_path__ + "static/media/ChannelSong.Telgu.4ee973f4.jpg";